var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_700_73)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.4417 3.12073H14.1743V11.1108H37.5567V7.23415C37.5567 4.96579 35.7107 3.12073 33.4417 3.12073Z",
    fill: "#CED9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5352 12.3403H0V4.92636C0 2.20972 2.21068 0 4.92828 0H12.1336C12.8497 0 13.5396 0.150925 14.1664 0.434509C15.0418 0.828964 15.7939 1.47913 16.3213 2.3286L22.5352 12.3403Z",
    fill: "#0065B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42 14.0001V37.8815C42 40.1527 40.1511 42 37.8789 42H4.12111C1.84891 42 0 40.1527 0 37.8815V9.88062H37.8789C40.1511 9.88062 42 11.7286 42 14.0001Z",
    fill: "#006FC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42 14.0001V37.8815C42 40.1527 40.1511 42 37.8789 42H21V9.88062H37.8789C40.1511 9.88062 42 11.7286 42 14.0001Z",
    fill: "#0862A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.048 25.9398C32.048 32.0322 27.0919 36.9887 21.0001 36.9887C14.9083 36.9887 9.95215 32.0322 9.95215 25.9398C9.95215 19.8483 14.9083 14.8918 21.0001 14.8918C27.0919 14.8918 32.048 19.8483 32.048 25.9398Z",
    fill: "#E7ECFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0479 25.9398C32.0479 32.0322 27.0918 36.9887 21 36.9887V14.8918C27.0918 14.8918 32.0479 19.8483 32.0479 25.9398Z",
    fill: "#CED9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5612 26.0754C24.3308 26.2705 24.0485 26.3657 23.7688 26.3657C23.4185 26.3657 23.0705 26.2173 22.827 25.9283L22.2307 25.2214V29.8494C22.2307 30.5288 21.6795 31.0799 21.0002 31.0799C20.3209 31.0799 19.7698 30.5288 19.7698 29.8494V25.2214L19.1734 25.9283C18.7344 26.4477 17.9587 26.514 17.4392 26.0754C16.9201 25.6373 16.8535 24.8612 17.2915 24.3418L19.7271 21.4544C20.0447 21.0788 20.508 20.8629 21.0002 20.8629C21.4924 20.8629 21.9558 21.0788 22.2733 21.4544L24.7089 24.3418C25.147 24.8612 25.0803 25.6373 24.5612 26.0754Z",
    fill: "#6C8DEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.561 26.0754C24.3306 26.2705 24.0483 26.3657 23.7686 26.3657C23.4183 26.3657 23.0703 26.2173 22.8268 25.9283L22.2305 25.2214V29.8494C22.2305 30.5288 21.6793 31.0799 21 31.0799V20.8629C21.4922 20.8629 21.9555 21.0788 22.2731 21.4544L24.7087 24.3418C25.1467 24.8612 25.0801 25.6373 24.561 26.0754Z",
    fill: "#3B67E9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_700_73"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.6c276d72c861e7a308533915ffdf04b6.svg";
export { ForwardRef as ReactComponent };